import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, TrendingDown, HelpCircle, Compass, BatteryWarning } from 'lucide-react';
export function ProblemaSection() {
  const painPoints = [{
    icon: <TrendingDown className="w-6 h-6 text-brand-orange" data-id="element-152" />,
    text: 'Ya estás vendiendo, pero no tenés estabilidad'
  }, {
    icon: <BatteryWarning className="w-6 h-6 text-brand-orange" data-id="element-153" />,
    text: 'Tenés meses buenos y meses flojos'
  }, {
    icon: <HelpCircle className="w-6 h-6 text-brand-orange" data-id="element-154" />,
    text: 'No hay un sistema claro detrás de tus ventas'
  }, {
    icon: <Compass className="w-6 h-6 text-brand-orange" data-id="element-155" />,
    text: 'Sentís que estás improvisando todo el tiempo'
  }, {
    icon: <AlertCircle className="w-6 h-6 text-brand-orange" data-id="element-156" />,
    text: 'Te cuesta escalar sin quemarte'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-brand-black text-white" data-id="element-157">
      <div className="max-w-5xl mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.3
      }} className="text-center mb-16" data-id="element-159">
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6" data-id="element-160">
            ¿Te sentís identificado?
          </h2>
          <div className="w-24 h-1 bg-brand-orange mx-auto rounded-full" data-id="element-161"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-162">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.25,
          delay: index * 0.08
        }} className="bg-white/5 border border-white/10 rounded-2xl p-6 flex items-start gap-4 hover:bg-white/10 transition-colors" data-id="element-163">
              <div className="bg-brand-black p-3 rounded-xl border border-white/10 shrink-0" data-id="element-164">
                {point.icon}
              </div>
              <p className="text-lg font-medium pt-1" data-id="element-165">{point.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.15
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-166">
          <a href="#" className="w-full sm:w-auto bg-brand-orange text-brand-black font-bold text-lg px-8 py-4 rounded-xl shadow-lg hover:scale-[1.03] transition-transform text-center" data-id="element-167">
            Escalar mi negocio ahora
          </a>
          <a href="https://wa.me/5491100000000" className="w-full sm:w-auto text-white font-medium hover:text-brand-orange transition-colors text-center underline underline-offset-4" data-id="element-168">
            Consultar por WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}